/* eslint-disable import/prefer-default-export */
export const creators = [
  {
    id: '01',
    name: 'Santiago Valencia',
    linkedin: 'https://www.linkedin.com/in/santiagovalenciaalvarez/',
    github: 'https://github.com/santy289',
    email: 'mailto: santiago.valencia4@udea.edu.co',
  },
  {
    id: '02',
    name: 'Norbey Vásquez',
    linkedin: 'https://www.linkedin.com/in/nvasquezt/',
    github: 'https://github.com/nvasquezt',
    email: 'mailto: lic.vasquezt@gmail.com',
  },

  {
    id: '03',
    name: 'Daniel Arteta',
    linkedin: 'https://www.linkedin.com/in/danielartetasalazar/',
    github: 'https://github.com/Danatts',
    email: 'mailto: danielatts97@gmail.com',
  },
  {
    id: '04',
    name: 'Julian Salamanca',
    linkedin: 'https://www.linkedin.com/in/julian-steven-salamanca-hernandez-502768239/',
    github: 'https://github.com/julians55',
    email: 'mailto: jsalamancah@unal.edu.co',
  },
];
